
/* Shared Eastern Time shipping-cutoff logic for product pages and cart drawer. */
(() => {
  const easternFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function easternParts(date) {
    const parts = {};
    easternFormatter.formatToParts(date).forEach(({ type, value }) => {
      if (type !== 'literal') parts[type] = Number(value);
    });
    return parts;
  }

  function easternEpoch(year, month, day, hour, minute) {
    const wall = Date.UTC(year, month - 1, day, hour, minute);
    let epoch = wall;
    for (let i = 0; i < 3; i++) {
      const p = easternParts(new Date(epoch));
      const actualWall = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      epoch -= actualWall - wall;
    }
    return epoch;
  }

  function getNextCutoff(now = Date.now()) {
    const config = document.getElementById('WisentShippingConfig');
    if (!config) return null;

    const hour = Number(config.dataset.cutoffHour ?? 12);
    const minute = Number(config.dataset.cutoffMinute ?? 0);
    const closed = new Set((config.dataset.blackoutDates || '')
      .split(/[\s,;]+/).filter(d => /^\d{4}-\d{2}-\d{2}$/.test(d)));
    const et = easternParts(new Date(now));

    for (let offset = 0; offset < 370; offset++) {
      const day = new Date(Date.UTC(et.year, et.month - 1, et.day + offset));
      const iso = day.toISOString().slice(0, 10);
      if (day.getUTCDay() === 0 || day.getUTCDay() === 6 || closed.has(iso)) continue;

      const epoch = easternEpoch(day.getUTCFullYear(), day.getUTCMonth() + 1,
        day.getUTCDate(), hour, minute);
      if (epoch <= now) continue;
      return { epoch, isToday: offset === 0, date: iso };
    }
    return null;
  }

  function updateCartLabels() {
    const labels = document.querySelectorAll('[data-wisent-shipping-label]');
    if (!labels.length) return;
    const next = getNextCutoff();
    const weekday = next && new Intl.DateTimeFormat('en-US', {
      weekday: 'long', timeZone: 'UTC'
    }).format(new Date(`${next.date}T12:00:00Z`));

    labels.forEach(label => {
      const textNode = label.querySelector('[data-wisent-shipping-text]');
      if (!textNode) return;
      let text;
      switch (label.dataset.status) {
        case 'out_of_stock': text = 'Out of Stock'; break;
        case 'available_to_order': text = 'Ships in 1–3 Business Days'; break;
        default:
          text = !next ? 'Shipping schedule unavailable'
            : next.isToday ? 'In Stock – Ships Today'
            : `In Stock – Ships ${weekday}`;
      }
      if (textNode.textContent.trim() !== text) textNode.textContent = text;
    });
  }

  window.WisentShipping = { getNextCutoff, updateCartLabels };

  function boot() {
    updateCartLabels();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(updateCartLabels).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateCartLabels();
  });
  window.setInterval(() => { if (!document.hidden) updateCartLabels(); }, 1000);
})();
